import Vue from 'vue';
import giftCards from './giftCards';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions/actions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { giftCards },
  state,
  getters,
  mutations,
  actions
});
